var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"full-page",attrs:{"style-fn":_vm.pageHeight}},[_c('router-view',{key:_vm.$route.params.portfolioId})],1)}
var staticRenderFns = []

export { render, staticRenderFns }